/*
 * What the card reader's state must be when a basket begins.
 *
 * Three paths open the payment screen — a new sale, a table's bill, and the
 * reset after a completed sale — and each one used to spell these fields out
 * by hand. Two of them cleared the lock and one did not, so a single unknown
 * card result leaked into every later basket: the payment screen opened on
 * «نتیجه پرداخت نامشخص است» with the card button dead, and the only ways out
 * were finishing a cash sale or restarting the till.
 *
 * The lock is right to exist — an unknown result means the customer may
 * already have been charged, and the basket must not be charged again. But it
 * belongs to the basket that earned it. The guard upstream blocks on
 * clientRef, so a basket with a fresh ref is one the agent would accept; a
 * lock that outlives its ref refuses a charge nothing is actually refusing.
 *
 * One definition, used by all three, so they cannot disagree again.
 */
export interface CardFields {
  /** 'idle' until a charge is in flight. */
  state: 'idle';
  /** The last reader outcome. Null means nothing has been attempted. */
  outcome: null;
  /** Whether this basket is barred from charging. */
  blocked: false;
}

export function freshCard(): CardFields {
  return { state: 'idle', outcome: null, blocked: false };
}
